'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Type = {
  preroll: 'preroll',
  instream: 'instream'
};

var Media = {
  video: 'video',
  audio: 'audio',
  display: 'display'
};

var Status = {
  loaded: 'loaded',
  refresh: 'refresh',
  loading: 'loading',
  playing: 'playing',
  progress: 'progress',
  paused: 'paused',
  resumed: 'resumed',
  stopped: 'stopped',
  ended: 'ended',
  error: 'error',
  volume: 'volume',
  setLearnMore: 'setLearnMore',
  requestInstreamAds: 'requestInstreamAds',
  updateInstreamParams: 'updateInstreamParams'
};

var Logging = {
  error: 'error',
  info: 'info'
};

exports.default = {
  Type: Type,
  Media: Media,
  Status: Status,
  Logging: Logging
};